module.exports = __webpack_public_path__ + "static/datbim-plugin-archicad-e4cb6cbb0e471efb4c1d6b15478b9a6e.png";